import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-code-of-ethics',
  templateUrl: './code-of-ethics.component.html',
  styleUrls: ['./code-of-ethics.component.scss']
})
export class CodeOfEthicsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
